import { render, staticRenderFns } from "./NewReleaseConfirmationWarning.vue?vue&type=template&id=5e899187&scoped=true"
import script from "./NewReleaseConfirmationWarning.vue?vue&type=script&lang=js"
export * from "./NewReleaseConfirmationWarning.vue?vue&type=script&lang=js"
import style0 from "./NewReleaseConfirmationWarning.vue?vue&type=style&index=0&id=5e899187&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e899187",
  null
  
)

export default component.exports